const getPlacesImplementation = require("./places");

module.exports = {
    getPlacesImplementation,
};
